import { getNullDecision } from "@customink/signalmizely-web";
import { useSignalmizely } from "./useSignalmizely.js";
import { useFlagData } from "./useFlagData.js";
export function useFlagVariation(flagKey, options = {}) {
    const helpers = useSignalmizely();
    const { data, isLoading, error } = useFlagData(flagKey, (flagKey, options) => helpers.flagVariation(flagKey, options), options, helpers);
    if (!helpers) {
        return {
            variation: getNullDecision(flagKey).variationKey,
            isLoading: true,
            error: null,
        };
    }
    return {
        variation: data,
        isLoading,
        error,
    };
}
